import React from 'react';
import { Link } from 'react-router-dom';
import image from '../Image/1_bwhgJ19iXhcyDJR1uH4-kw.png'
import ToolsBD from '../Image/toolsbd/Screenshot (75).png'
import Bikes from '../Image/bikes/Screenshot (85).png'
import Wildfile from '../Image/wildlife/Screenshot (88).png'

const Projects = () => {
    return (
        <div class="flex justify-center mt-24  ">
            <div class="">

                <img src={image} class="max-w-sm mx-auto rounded-lg " />
                <h1 class="text-5xl font-bold text-white my-12  text-center">My Projects</h1>

                <div className='text-black gap-10 lg:flex justify-center'>

                    <div class="card w-96 my-12 bg-base-100 shadow-xl">
                        <figure><img src={ToolsBD} alt="ToolsBD" /></figure>
                        <div class="card-body">
                            <h2 class="card-title">
                                <p className='text-xl font-bold'><a href="">Bikes store</a></p>
                                <div class="badge  badge-secondary">NEW</div>

                            </h2>

                            <p>This project is about a tools store. I use the Firebase Authentication system  on this project. Users can’t book products without login with email or google.</p>
                            <div class="card-actions justify-end">
                                <Link to='/tools' class="badge w-full py-5 bg-black text-xl text-white font-bold badge-outline">See more</Link>
                            </div>
                        </div>
                    </div>


                    <div class="card w-96 bg-base-100 my-12 shadow-xl">
                        <figure><img src={Bikes} alt="ToolsBD" /></figure>
                        <div class="card-body">
                            <h2 class="card-title">
                                <p className='text-xl font-bold'><a href="">Bikes store</a></p>
                                <div class="badge  badge-secondary">NEW</div>

                            </h2>

                            <p>This project is about a bike store. Users can log in here with email or google account.
                                Users can manage their products,  add products and also can remove products.</p>
                            <div class="card-actions justify-end">
                                <Link to='/bikes' class="badge w-full py-5 bg-black text-xl text-white font-bold badge-outline">See more</Link>
                            </div>
                        </div>
                    </div>
                    <div class="card w-96 bg-base-100 my-12 shadow-xl">
                        <figure><img src={Wildfile} alt="ToolsBD" /></figure>
                        <div class="card-body">
                            <h2 class="card-title">
                                <p className='text-xl font-bold'><a href="">Wildlife photography</a></p>
                                <div class="badge  badge-secondary">NEW</div>
                            </h2>
                            <p>This project is about Wildlife Photography. I use the Firebase Authentication system  on this project.
                                User can’t use this site properly without verifying his account.
                            </p>
                            <div class="card-actions justify-end">
                                <Link to='/wildlife' class="badge w-full py-5 bg-black text-xl text-white font-bold badge-outline">See more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Projects;